import { render, staticRenderFns } from "./myWindow.vue?vue&type=template&id=35059497"
import script from "./myWindow.vue?vue&type=script&lang=js"
export * from "./myWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports